import React, { Component } from 'react';
import jQuery from 'jquery';
import JSZip from 'jszip';

import Core from './../../../Core/Core';
import Exporter from './../../../Core/Exporter';

import QueryBuilder from './../../QueryBuilder/QueryBuilder';

import Header from './../../Header';
import Export from './../Export/Export';
import Clients from './../../Client/Clients';
import SearchForm from './../../Search/SearchForm';
import Stats from './../../Search/Stats';
import ModalProgress from './../../Search/ModalProgress';
import ErrorBoundary from '../ErrorBoundary';
import ErrorManager from '../../../Core/ErrorManager';

require('bootstrap');

class Search extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            "clients" : [],
            "advanced" : false, 
            "stats" : {},
            "totalRows": 0,
            "progressBar": 0,
            "progressAction": "",
            "progressSituation" : "" 
        }
        this.handleSearchForm = this.handleSearchForm.bind(this);
        this.handleQueryBuilder = this.handleQueryBuilder.bind(this);
        this.setPage = this.setPage.bind(this);
        this.sort = this.sort.bind(this);
        this.blobToBase64 = this.blobToBase64.bind(this);

        this.ExportCSV = this.ExportCSV.bind(this);

        this.load = this.load.bind(this);

        

        this.timer = null;
        this.lastRequest = "";
        this.page = null;
        this.length = 20;
        this.selectedColumn = "";
        this.order = "";

        if (Core.Instance.user == null){
            window.location.href="/login";
        } else {
            this.load();
        }
    }

    load()
    {
        Core.Instance.Request(Core.Address+"Stats", null, "GET")
        .then((json) => {
            this.setState({
                "stats" : json != null ? json : {}
            })
        });
    }

    componentDidMount()
    {
        document.title = "W-F: Recherche";

        if(this.props.match.params.data != null && Core.Instance.user)
        {
            this.handleSearchForm(this.props.match.params.data);
        }
    }

    handleSearchForm(value)
    {
        Core.Instance.ShowLoading();
        this.setState({
            "totalRows" : '?'
        });

        if(value == null || value == "")
        {
            this.setState({
                "clients" : []
            });
            return;
        }
        let clients = [];

        value = value.trim();
        value = value.replace('-',' ');
        value = "*"+value+"*";
        
        if(value.includes('@')){
            this.lastRequest = Core.Address+"Search/Client->email eq "+value;
        }else{
            this.lastRequest = Core.Address+"Search/Client->name eq "+value+" or Client->phone eq "+value+" or Client->phone_mobile eq "+value
            +" or Client->address eq *"+value+"*"
            +" or Client->postal_code eq *"+value+"*"
            +" or Client->city eq *"+value+"*"
            +" or Client->siret eq "+value+""
            +" or Car->code eq "+value+""
            +" or Car->vin eq "+value+"";
        }

        this.page = 0;
        Core.Instance.Request(this.lastRequest+"?offset="+this.page*this.length+"&limit="+this.length, null, "GET")
        .then((json) => {
            clients = json != null ? json : [];
            if(clients.length == 1)
            {
                window.location.href = "/client/"+clients[0].id;
                return;
            }
            this.setState({
                "clients" : clients
            });
        })
        let totalRequest = "";
        if(value.includes('@')){
            totalRequest =  Core.Address+"Total/Client->email eq "+value;
        }else{
            totalRequest =  Core.Address+"Total/Client->name eq "+value+" or Client->phone eq "+value+" or Client->phone_mobile eq "+value+" or Client->email eq *"+value+"*"
            +" or Client->address eq *"+value+"*"
            +" or Client->postal_code eq *"+value+"*"
            +" or Client->city eq *"+value+"*"
            +" or Client->siret eq "+value+""
            +" or Car->code eq "+value+""
            +" or Car->vin eq "+value+"";
        }

        Core.Instance.Request(totalRequest, null, "GET")
        .then((json) => {
            if(json && json[0]){
                this.setState({
                    "totalRows" : json[0]["total_rows"]
                });
            }
        })
    }

    async ExportCSV(columns)
    {
        const { totalRows } = this.state;
        let blob = null;
        const zip = new JSZip();
        let i = 0;
        let keepGenerating = true;
        jQuery("#downloadProgress").modal('toggle');
        while (keepGenerating) {
            this.setState({
                "progressSituation" : ""
            })
            this.setState({
                "progressBar" : 0
            })
            this.setState({
                "progressAction" : "Génération de l'export : "+ i*15000 +" lignes exportées actuellement"
            })
            let address = Core.Address+"ExportSearch?offset="+i*15000+"&limit=15000&lastRequest="+this.lastRequest.replace(Core.Address+"Search/", '')+"&columns="+columns;

            let options = {
                method: "GET",
                mode: "cors",
            };

            let nb = i+1;

            if(address.indexOf(Core.Address) != -1)
            {
                let token = Core.Instance.user != null ? Core.Instance.user.token : null;
                if(options.headers == null)
                    options.headers =  { 'X-Authorization': "Token "+token };
                else 
                    options.headers['X-Authorization'] = "Token "+token;
            }

            let chunks = [];
            try {
                const response = await fetch(address, options);
                try{
                    const responseCopy = response.clone();
                    const json = await responseCopy.json();
                    if(json.error){
                        keepGenerating = false;
                        break;
                    }
                }
                catch (error){}
                const reader = response.body.getReader();
                const contentLength = response.headers.get('Content-Length');

                let receivedLength = 0;
                this.setState({
                    "progressAction" : "Téléchargement"
                })
                while(true) {
                    const {done, value} = await reader.read();
                    if (done) {
                        break;//Sortie de la boucle
                    }
                    chunks.push(value);
                    receivedLength += value.length;

                    let percentage = receivedLength/contentLength *100;

                    this.setState({
                        "progressBar" : percentage
                    })
                    this.setState({
                        "progressSituation" : Math.round(percentage)+"%"
                    })
                }

                blob = new Blob(chunks);

                // ADD file to zip
                const b64 = await this.blobToBase64(blob);
                let filename = 'export-'+nb+'.csv'
                zip.file(filename, b64, {base64: true});

                i++;
            } catch(error) {
                keepGenerating = false;
            }
        }
        jQuery("#downloadProgress").modal('hide');


        if (i<2) {
            // Simple fichier CSV

            // Create blob link to download
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            let filename = 'export-'+i+'.csv'
            link.setAttribute('download', filename);
            //Append to html page
            document.body.appendChild(link);
            //Force download
            
            link.click();
            // Clean up and remove the link
            link.parentNode.removeChild(link);
        }else{
            // Archive zip
            let content = await zip.generateAsync({type:"base64"});

            // Create blob link to download
            const link = document.createElement('a');
            link.href = "data:application/zip;base64," + content;
            let filename = 'export.zip';
            link.setAttribute('download', filename);
            //Append to html page
            document.body.appendChild(link);
            //Force download
            
            link.click();
            // Clean up and remove the link
            link.parentNode.removeChild(link);
        }
    }

    async blobToBase64(blob) {
        const reader = new FileReader();
        await new Promise((resolve, reject) => {
            reader.onload = resolve;
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
        return reader.result.split(',')[1];
    }

    setPage(page)
    {
        if(this.lastRequest == null || page < 0)// this.state.clients.length <= 0
            return;
        this.page = page;
        Core.Instance.Request(this.lastRequest+"?offset="+this.page*this.length+"&limit="+this.length, null, "GET").then((json) => {
            if(json == null)
                json = [];

            this.setState({
                "clients" : json
            });
        });
    }

    sort(column)
    {
        if(this.lastRequest == null || this.state.clients.length <= 0)
            return;
        
        //Définit l'ordre
        if(this.selectedColumn === column){
            if(this.order === "ASC"){
                this.order = "DESC";
            }else{
                this.order = "ASC";
            }
        }else{
            this.selectedColumn = column;
            this.order = "ASC";
        }

        this.page= 0;
        Core.Instance.ShowLoading();
        Core.Instance.Request(this.lastRequest+"?offset="+this.page*this.length+"&limit="+this.length+"&selectedColumn="+this.selectedColumn+"&order="+this.order, null, "GET").then((json) => {
            if(json == null)
                json = [];
            this.setState({
                "clients" : json
            });
        });
    }


    handleQueryBuilder(filters){
        if(filters){
            this.lastRequest = Core.Address+"Search/"+filters;
            this.page = 0;
            Core.Instance.Request(this.lastRequest+"?offset="+this.page*this.length+"&limit="+this.length, null, "GET").then((json) => {
                if(json == null)
                    json = [];
                
                if(json.length == 1)
                {
                    window.location.href = "/client/"+json[0].id;
                    return;
                }

                this.setState({
                    "clients" : json
                });
            })

            let totalRequest = Core.Address+"Total/"+filters;
            Core.Instance.Request(totalRequest, null, "GET")
            .then((json) => {
                this.setState({
                    "totalRows" : json[0]["total_rows"]
                });
            })
        }
    }

    render()
    {
        let display_advanced = false;
        const allowed = [
            'Jimmy.cohen@spider-vo.com',
            'cedrick.delmotte@gmail.com',
            'vmancier@ensc.fr',
            'benjifeles@gmail.com',
            'isauresynethis@gmail.com',
            'margaux.hill.synethis@gmail.com'
        ];

        if (allowed.includes(Core.Instance.user.email)) {
            display_advanced = true;
        }
       
        return (
            <ErrorBoundary>
                <Header buttons={ allowed ? [
                        <div className="dropdown btn-group" key="exportDDL">
                            <button className="btn btn-primary" type="button" data-toggle="modal" data-target="#exportModal">
                            <li className="fas fa-file-export"></li> Exporter
                            </button>
                        </div>
                    ] : []} />
                <Export exportCSV={this.ExportCSV} />
                <div className="container-fluid">
                    <div className="row">
                        {
                            this.state.advanced == false &&
                            <div className="col">
                               <div className="card m-3 p-3" >
                                    <div className="card-body">
                                        <div className="card-title">
                                            <div className="row no-gutters">
                                                <div className="col-12 col-md-8">
                                                    <span className="h4 align-middle" >
                                                        <li className="fas fa-search"> </li> Recherche Libre
                                                    </span>
                                                </div>
                                                {
                                                    display_advanced == true &&
                                                    <div className="col-12 col-md-4">
                                                        <div className="text-md-right pt-1">
                                                            <a href="#" onClick={ () => { this.setState({"advanced" : true }) } }><u>Recherche avancée</u></a>    
                                                        </div> 
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        <SearchForm onChange={ this.handleSearchForm } value={ this.props.match.params.data } />
                                    </div>
                                </div>
                            </div>
                        }
                        <Stats stats={this.state.stats} />
                    </div>

                    {
                        this.state.advanced &&
                        <div className="row">
                            <div className="col">
                                <div className="card m-3 p-3">
                                    <div className="card-body">
                                        <div className="card-title">
                                            <span className="h4">Recherche avancée</span>
                                            <span className="float-right pt-3">
                                                <a href="#" onClick={ () => { this.setState({"advanced" : false }) } }>Recherche simple</a>    
                                            </span>
                                        </div>
                                        <div className="row">
                                            <QueryBuilder handleQueryBuilder={this.handleQueryBuilder}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    <div className="row m-0">
                        <div className="col">
                            <div className="card p-3" >
                                <div className="card-body">
                                    <Clients clients={ this.state.clients } page={ this.page } setPage={ this.setPage } totalRows={ this.state.totalRows } length={ this.length } sort={this.sort} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <ModalProgress progressAction={ this.state.progressAction } progressBar={ this.state.progressBar } progressSituation={ this.state.progressSituation } />     
                </div>
            </ErrorBoundary>
        );
    }
}

export default Search;



// WEBPACK FOOTER //
// ./src/Components/Views/Search/Search.js